module.exports = __webpack_public_path__ + "assets/media/edit_title_icon.60e36f2f.svg";